module.exports = __webpack_public_path__ + "img/next-arrow.9c5c8399.svg";